export default __webpack_public_path__ + "static/media/expand-icon-desktop.210d667b.svg";